module.exports = __webpack_public_path__ + "static/icons/icon-heart--outline-5f2812322d10503a7708b8f83a5c6d14.svg";